export default "__VITE_ASSET__CVKWS1ku__"